<template>
    <div class="softwareOrderDetails">
        <!-- 订单状态 -->
        <div class="detailsState">
            <div class="detailsState_one">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <p class="detailsState_one_title">订单状态</p>
                <span v-if="processActive==='1000'">等待供应商确认订单中...</span>
                <span v-if="processActive==='1001'">供应商正在线下部署，请等待部署完成..</span>
                <span v-if="processActive==='1002'">确认供应商是否部署完成...</span>
                <span v-if="processActive==='1003'">请评价服务...</span>
                <span v-if="processActive==='1004'">该订单已完成</span>
                <span v-if="processActive==='1009'">该订单已取消</span>
            </div>
            <div class="detailsState_one" v-if="processActive==='1001'">
                <p>
                    您还有
                    <span class="detailsState_one_time">{{day}}天{{hr}}小时{{min}}分{{sec}}秒</span>
                    来确认部署完成
                </p>
            </div>
        </div>
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <div class="processItem" v-for="(item,index) in processList" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
            </div>
            <!--订单信息-->
            <div class="orderInformation">
                <div class="orderTop">
                    <h3>订单信息</h3>
                    <!--<div class="orderItem"  style="display:flex">
                        <div class="name" style="min-width:60px">联系平台</div>
                        &lt;!&ndash; <div class="content" style="display:flex;"><span style="width:168px;">{{ order.enterPriseName }} </span><i class="iconfont icon-weixin" @click="startChat(order.enterPriseId)"></i></div> &ndash;&gt;
                    </div>-->
                </div>
                <div class="orderBottom">
                    <div class="orderItem" style="align-items:center">
                        <div class="name">订单编号：</div>
                        <div class="content">{{ order.orderNo }}</div>
                    </div>
                    <div class="orderItem"  style="align-items:center">
                        <div class="name">创建时间：</div>
                        <div class="content">{{ order.createDate }}</div>
                    </div>
                </div>
            </div>
            <!--服务信息-->
            <div class="printInformation">
                <h3>软件信息</h3>
                <div class="printTableContent">
                    <div class="tableHeader">
                        <div class="name">软件名称</div>
                        <div class="price">套餐版本</div>
                        <div class="price">计费模式</div>
                        <div class="price">单价</div>
                        <div class="price">数量</div>
                        <div class="price">实付款</div>
                        <div class="price">软件有效期开始时间</div>
                        <div class="price">软件有效期结束时间</div>
                    </div>
                    <div class="tableBody">
                        <div class="name">
                            <div class="orderInfo">
                                <img :src="order.softwareLogo" alt="">
                                <div class="infoContent">
                                    <div class="infoName" :title="order.softwareName">{{ order.softwareName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                {{ order.softwareModelName }}
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                {{ order.billingModeName }}
                            </div>
                        </div>
                        <div class="price money">
                            <div>
                                ¥ {{ order.modelPrice }}
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                {{ order.buyNum }}
                            </div>
                        </div>
                        <div class="price money">
                            <div>
                                ¥ {{ order.actualPayment }}
                            </div>
                        </div>
                         <div class="price">
                            <div>
                               {{ order.validityStartDate == null ? '' : order.validityStartDate }}
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                {{ order.validityEndDate == null ? '' : order.validityEndDate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--功能按钮-->
            <div class="functionButton">
                <div class="functionButton">
                    <el-button type="primary" v-show="processActive === '1002'" @click="makesureSubmit(order.uuid)">确认部署完成</el-button>
                    <el-button type="primary" v-show="processActive === '1000'" @click="cancelOrder(order)">取消订单</el-button>
                    <el-button type="primary" v-show="processActive === '1003'" @click="toEvaluate(order)">评价</el-button>
                </div>
            </div>
        </div>

        <!-- 取消订单 -->
        <el-dialog
            title="取消订单"
            :visible.sync="cancelDialogVisible"
            :close-on-click-modal="false"
            width="1000px">
            <div class="logisticsDialog">
                <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                    <el-form-item class="addressList">
                        <el-select v-model="cancelUuid" placeholder="取消原因">
                            <el-option v-for="(item,index) in cancelList" :key="index"
                                       :label="item.name"
                                       :value="item.uuid+','+item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="cancelSubmit">确定</el-button>
                        <el-button @click="cancelDialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!--评价弹出框-->
        <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.descriptionPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.servicePoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">专业程度</div>
                            <el-rate
                                v-model="evaluateForm.transportPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group
                            v-model="evaluateForm.evaluationTagList"
                            class="evaluateTag"
                        >
                            <el-checkbox-button
                                v-for="tag in tagList"
                                :label="tag"
                                :key="tag.tagUuid"
                            >{{ tag.tagName }}</el-checkbox-button
                            >
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6 }"
                            placeholder="请输入内容"
                            v-model="evaluateForm.evaluationContent"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="evaluateDialogVisible = false">取 消</el-button>
            <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import { getSoftwareOrderDetailByUuid,updateSoftwareOrder,
        saveEvaluation, getDictionaryItem } from '../../../utils/interface';

    export default {
        name: "softwareOrderDetails",
        data() {
            return {
                stepLoading: false,
                processActive: '',
                processList: [
                    {
                        id: "1000",
                        name: "待确认",
                    },
                    {
                        id: "1001",
                        name: "待部署",
                    },
                    {
                        id: "1002",
                        name: "部署完成",
                    },
                    {
                        id: "1003",
                        name: "待评价",
                    },
                    {
                        id: "1004",
                        name: "订单完成",
                    },
                ],
                day: 0,
                hr: 0,
                min: 0,
                sec: 0,
                uuid:"",
                order:"",
                // 取消
                cancelDialogVisible: false,
                cancelList: [],
                cancel: null,
                cancelUuid: "",
                cancelReason: "",
                cancelRules: {
                    cancel: [
                        {required: true, message: '请选择取消原因', trigger: 'change'}
                    ]
                },
                // 评价
                evaluateDialogVisible: false,
                evaluateForm: {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: "",
                },
                tagList: [],
            }
        },
        created(){
            this.uuid = this.$route.query.uuid;
            this.getSoftwareOrderDetail();
            this.getDictionaryItem();
        },
        mounted() {
            this.countdown()
        },
        methods: {
            // 获取字典值
            getDictionaryItem() {
                getDictionaryItem({groupCode: "software_evaluation_tag"}).then((res) => {
                    this.tagList = [];
                    res.forEach((item, index) => {
                        this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                    });
                });
            },
            // 点击打开评价弹出框
            toEvaluate(order) {
                this.order = order;
                console.log(order);
                this.evaluateForm = {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: "",
                };
                this.evaluateDialogVisible = true;
            },
            // 评价提交
            evaluateSubmit() {
                this.stepLoading = true;
                if (
                    this.evaluateForm.descriptionPoint &&
                    this.evaluateForm.servicePoint &&
                    this.evaluateForm.transportPoint
                ) {
                    this.evaluateForm.orderNo = this.order.orderNo;
                    this.evaluateForm.orderUuid = this.order.uuid;
                    this.evaluateForm.orderType = 'SOFTWARE';
                    this.evaluateForm.evaluationType = 'NORMAL';
                    // this.evaluateForm.sellerName = this.order.modelCreatorName;
                    // this.evaluateForm.sellerUuid = this.order.modelCreatorUuid;
                    this.evaluateForm.orderName = this.order.softwareName;
                    this.evaluateForm.orderAmount = this.order.actualPayment;

                    saveEvaluation(this.evaluateForm).then((response) => {
                        if (response.success) {
                            this.evaluateDialogVisible = false;
                            this.getSoftwareOrderDetail();
                            this.$message({
                                type: "success",
                                message: "评价成功",
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                    });
                } else {
                    this.$message.warning("请选择评价等级");
                }
                setTimeout(() => {
                    this.stepLoading = false;
                }, 1000);
            },
            // 取消
            cancelOrder(item){
                getDictionaryItem({groupCode:"software_cancel_reason"}).then((res)=>{
                    this.cancelList = res;
                    this.uuid = item.uuid;
                    this.cancelDialogVisible = true;
                });
            },
            // 取消确定
            cancelSubmit(){
                if(this.cancelUuid == ""){
                    this.$message.error('请选择取消原因！');
                    return false;
                }
                let reason = this.cancelUuid.split(",");
                updateSoftwareOrder({uuid:this.uuid,state:"1009",cancelReasonUuid: reason[0], cancelReason:reason[1] }).then((res)=>{
                    if(res.success){
                        this.$message.success('订单取消成功！');
                        this.cancelDialogVisible = false;
                        this.getSoftwareOrderDetail();
                    }
                });
            },
            // 确定部署完成
            makesureSubmit(uuid){
                this.$confirm("是否确认已部署完成", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateSoftwareOrder({uuid:uuid,state:"1003" }).then((res)=>{
                            if(res.success){
                                this.$message.success('操作成功！');
                                this.cancelDialogVisible = false;
                                this.getSoftwareOrderDetail();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消确认已部署完成",
                        });
                    });

            },
            getSoftwareOrderDetail(){
                // let params = {
                //     uuid:this.uuid
                // };
                getSoftwareOrderDetailByUuid(this.uuid).then((res)=>{
                    if(res) {
                        this.order = res;
                        if(res.state == '1000'){
                            this.processActive ='1000';
                        }else if(res.state == '1001'){
                            this.processActive ='1001';
                        }else if(res.state == '1002'){
                            this.processActive ='1002';
                        }else if(res.state == '1003'){
                            this.processActive ='1003';
                        }else if(res.state == '1004'){
                            this.processActive ='1004';
                        }
                    }
                });
            },
            // 倒计时
            countdown() {
                // 定义结束时间戳
                let end = new Date('2022-01-02 00:00:00')
                // 定义当前时间戳
                let now = new Date()
                // 做判断当倒计时结束时都为0
                if (now >= end) {
                    this.day = 0
                    this.hr = 0
                    this.min = 0
                    this.sec = 0
                    return
                }
                // 用结束时间减去当前时间获得倒计时时间戳
                let msec = end - now
                let day = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
                let hr = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
                let min = parseInt(msec / 1000 / 60 % 60)//算出分钟数
                let sec = parseInt(msec / 1000 % 60)//算出秒数
                //给数据赋值
                this.day = day
                this.hr = hr > 9 ? hr : '0' + hr
                this.min = min > 9 ? min : '0' + min
                this.sec = sec > 9 ? sec : '0' + sec
                setTimeout(()=> {
                    this.countdown()
                }, 1000)
            },
        },
    }
</script>

<style scoped lang="less">
    p {
        margin: 0;
    }
    i {
        font-style: normal;
    }
    .softwareOrderDetails {
        background: #f5f5f5;
        // 订单状态
        .detailsState {
            background: #fff;
            font-size: 14px;
            padding: 26px 32px;
            margin-bottom: 8px;
            .detailsState_one {
                display: flex;
                align-items: center;
                position: relative;
                &:nth-of-type(1) {
                    margin-bottom: 16px;
                }
                i {
                    font-size: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                    position: absolute;
                    left: -24px;
                }
                span{
                    color: rgba(0,0,0,.5);
                }
                .detailsState_one_title {
                    font-size: 16px;
                    font-weight: 700;
                    margin-right: 8px;
                }
                .detailsState_one_time {
                    color: #1890ff;
                }
            }
        }
        // 报价流程
        .details {
            background: #fff;
            padding: 0 8px 150px;
            .detailsProcess {
                border-bottom: 1px solid #efefef;
                display: flex;
                align-items: center;
                .processItem{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    &:nth-last-child(1) .typeIcon {
                      display: none;
                    }
                    &:hover{
                        .process_type{
                            i {
                                background: #1890ff;
                                color: #fff;
                                border: 1px solid #1890ff;
                            }
                            p {
                                color: #000;
                            }
                        }
                    }
                }
                .process_type {
                    width: 232px;
                    height: 64px;
                    // line-height: 64px;
                    display: flex;
                    align-items: center;
                    // border-bottom: 2px solid #1890ff;
                    text-align: center;
                    justify-content: center;
                    i {
                        display: inline-block;
                        width: 24px;
                        height: 24px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 50%;
                        color: rgba(0, 0, 0, 0.15);
                        line-height: 27px;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .typeIcon {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                }
                .process_type2 {
                    border-bottom: 3px solid #1890ff;
                    i {
                        background: #1890ff;
                        color: #fff;
                        border: 1px solid #1890ff;
                    }
                    p {
                        color: #000;
                    }
                }
            }
            .basicInformation{
                display: flex;
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .goodsItem{
                    display: flex;
                    padding-bottom: 14px;
                    font-size: 14px;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                        min-width: 80px;
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .orderInformation{
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .orderTop{
                    display: flex;
                    .orderItem{
                        padding-left: 50px;
                        i{
                            color: #1890FF;
                            padding-left: 10px;
                            cursor: pointer;
                        }
                    }
                }
                .orderBottom{
                    display: flex;
                }
                .orderItem{
                    font-size: 14px;
                    display: flex;
                    width: 20%;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .printInformation{
                padding: 25px 32px;
                border-bottom: 2px dashed #e7e7e7;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .printTableContent{
                    .tableHeader{
                        display: flex;
                        height: 54px;
                        background:rgba(0,0,0,.02);
                        line-height: 54px;
                        font-size: 14px;
                        color: #000000;
                        .name{
                            flex: 1;
                            padding: 0 30px;
                            min-width: 600px;
                        }
                    }
                    .tableBody{
                        display: flex;
                        align-items: center;
                        .name{
                            text-align: left;
                            min-width: 600px;
                        }
                        .explain {
                            padding: 20px;
                        }
                        .money {
                          color: #E42424;
                        }
                        .argumentsName {
                            padding-bottom: 8px;
                            font-size: 14px;
                            span{
                                color: rgba(51, 51, 51, 0.85);
                            }
                        }
                    }
                    .orderInfo {
                        padding: 30px 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 550px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }
                    .sort{
                        width: 60px;
                        text-align: center;
                        padding: 0 10px;
                    }
                    .name{
                        flex: 1;
                        padding: 0 10px;
                        text-align: center;
                        // min-width: 600px;
                    }
                    .explain{
                        text-align: center;
                        padding: 0 10px;
                        width: 400px;
                    }
                    .price{
                        text-align: center;
                        padding: 0 10px;
                        width: 176px;
                        font-size: 14px;
                    }
                    .num{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                }
            }
            .commodityPrices{
                padding: 20px 30px 0 0;
                .priceItem{
                    display: flex;
                    justify-content: flex-end;
                    padding-bottom: 15px;
                    font-size: 14px;
                    color: #404040;
                    .content{
                        min-width: 100px;
                        text-align: right;
                    }
                    &.fontWeight{
                        font-weight: 700;
                        .content{
                            color: #FF375F;
                        }
                    }
                }
            }
            .functionButton{
                position: fixed;
                bottom: 20px;
                right: 30px;
            }
        }
    }
    .billingInformation{
        .title{
            color: rgba(0, 0, 0, 0.85);
            padding: 5px 0 10px 15px;
            border-bottom: 1px solid #ddd;
            font-weight: 700;
        }
        .billingContent{
            padding: 10px 10px 0;
            color: rgba(0, 0, 0, 0.65);
            .billingItem{
                display: flex;
                padding-bottom: 10px;
            }
        }
    }
    .electronicInvoice {
        h3 {
            padding-bottom: 15px;
            color: #000;
            font-size: 15px;
        }

        .invoiceList {
            .invoiceItem {
                border: 1px solid #ddd;
                padding: 10px 50px 10px 15px;
                border-radius: 10px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                position: relative;

                .invoiceCheckBox {
                    padding-right: 15px;
                }

                .type {
                    font-size: 12px;
                    color: #666;
                    padding-bottom: 5px;
                }

                .name {
                    font-size: 15px;
                    color: #000;
                    padding-bottom: 5px;
                }

                .num {
                    font-size: 12px;
                    color: #333;
                }

                .edit {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    margin-top: -10px;
                    padding: 0;
                }
            }
        }

        .emailList {
            padding: 0 15px 15px;

            /deep/ .el-radio {
                margin-bottom: 15px;
                display: block;
                margin-right: 0;
            }
        }
    }
    .addressList{
        padding: 24px 15px 0;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
        .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/softwareOrderDetails.vue